
import React, { useState } from "react";
import { Check, X, CookingPot, Truck, CheckCircle2, CreditCard } from "lucide-react";

function Confirm({ title, message, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel}/>
      <div className="relative bg-white w-full max-w-md rounded-xl shadow-xl p-6">
        <div className="text-lg font-semibold mb-2">{title}</div>
        <div className="text-sm text-slate-600 mb-6">{message}</div>
        <div className="flex justify-end gap-3">
          <button className="px-3 py-2 rounded-lg bg-slate-100" onClick={onCancel}>Cancel</button>
          <button className="px-3 py-2 rounded-lg bg-emerald-600 text-white" onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}

export default function OrderActions({ order, onAction, onClose }) {
  const [confirm, setConfirm] = useState(null);

  const ask = (key, label) => {
    setConfirm({
      title: `${label}?`,
      message: `You are about to ${label.toLowerCase()} for order #${order.orderid}. This cannot be undone.`,
      onConfirm: async () => {
        setConfirm(null);
        await onAction?.(key, order);
      },
      onCancel: () => setConfirm(null)
    });
  };

  return (
    <div className="border rounded-xl p-4">
      <div className="font-semibold mb-3">Actions</div>
      <div className="grid grid-cols-2 gap-2">
        <button className="h-10 rounded-lg bg-emerald-600 text-white flex items-center justify-center gap-2"
          onClick={() => ask("accept", "Accept Order")}>
          <Check size={16}/> Accept
        </button>
        <button className="h-10 rounded-lg bg-rose-600 text-white flex items-center justify-center gap-2"
          onClick={() => ask("reject", "Reject Order")}>
          <X size={16}/> Reject
        </button>
        <button className="h-10 rounded-lg bg-indigo-600 text-white flex items-center justify-center gap-2"
          onClick={() => ask("prepared", "Mark as Prepared")}>
          <CookingPot size={16}/> Prepared
        </button>
        <button className="h-10 rounded-lg bg-blue-600 text-white flex items-center justify-center gap-2"
          onClick={() => ask("dispatched", "Dispatch Order")}>
          <Truck size={16}/> Dispatch
        </button>
        <button className="h-10 rounded-lg bg-green-600 text-white flex items-center justify-center gap-2"
          onClick={() => ask("delivered", "Mark Delivered")}>
          <CheckCircle2 size={16}/> Delivered
        </button>
        <button className="h-10 rounded-lg bg-teal-600 text-white flex items-center justify-center gap-2"
          onClick={() => ask("mark_paid", "Mark as Paid")}>
          <CreditCard size={16}/> Mark Paid
        </button>
      </div>

      <button className="mt-3 w-full h-10 rounded-lg bg-slate-100" onClick={onClose}>Close</button>

      {confirm && <Confirm {...confirm} />}
    </div>
  );
}
